import { C } from "./theme";

export const PENCIL = <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>;

// The 44px pencil that opens an item's editor, beside a row whose own tap does something else (Fears,
// Key Dates). `label` names what it edits.
export function EditButton({ label, onClick, style }) {
  return (
    <button onClick={onClick} aria-label={label}
      style={{ width: 44, height: 44, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "none", border: "none", cursor: "pointer", color: C.textMid, ...style }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{PENCIL}</svg>
    </button>
  );
}
